import MuiDialogContent from '@mui/material/DialogContent';

import { styled } from 'helpers';

import { Props } from './types';

export const DialogContent = styled(MuiDialogContent)<Props>`
  color: ${({ theme }) => theme.palette.blueGrey['A600']};
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  padding: 0 32px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding-left: ${({ theme }) => theme.spacing(3)};
    padding-right: ${({ theme }) => theme.spacing(3)};
  }
`;

export default DialogContent;
